export function buildAnswerTags(answers, t) {
  return [
    answers.mood ? t(`mood_${answers.mood}`) : null,
    answers.intensity ? t(`intensity_${answers.intensity}`) : null,
    answers.taste ? t(`taste_${answers.taste}`) : null,
    answers.bitterness ? t(`bitterness_${answers.bitterness}`) : null,
    answers.experimental ? t(`experimental_${answers.experimental}`) : null,
  ].filter(Boolean);
}

export function buildTasteProfile(answers, t) {
  const tasteMap = {
    clean_fresh: t("profile_clean"),
    fruity: t("profile_fruity"),
    bitter: t("profile_bitter"),
    malty: t("profile_malty"),
    sour: t("profile_sour"),
    roasted: t("profile_roasted"),
  };

  const intensityMap = {
    low: t("profile_intensity_low"),
    medium: t("profile_intensity_medium"),
    high: t("profile_intensity_high"),
    very_high: t("profile_intensity_very_high"),
  };

  const bitternessMap = {
    low: t("profile_bitterness_low"),
    medium: t("profile_bitterness_medium"),
    high: t("profile_bitterness_high"),
    very_high: t("profile_bitterness_very_high"),
  };

  const experimentalMap = {
    safe: t("profile_experimental_safe"),
    medium: t("profile_experimental_medium"),
    interesting: t("profile_experimental_interesting"),
    wild: t("profile_experimental_wild"),
  };

  return {
    taste: tasteMap[answers.taste] || "",
    intensity: intensityMap[answers.intensity] || "",
    bitterness: bitternessMap[answers.bitterness] || "",
    experimental: experimentalMap[answers.experimental] || "",
  };
}

export function getProductTitle(product) {
  return (
    product?.name ||
    product?.title ||
    product?.name_uk ||
    product?.name_en ||
    ""
  );
}

export function getProductImage(product) {
  return (
    product?.image_url ||
    product?.image ||
    product?.imageProxyUrl ||
    product?.image_proxy_url ||
    product?.cover ||
    ""
  );
}

export function getProductPrice(product, t) {
  const price = product?.price ?? product?.price_value ?? product?.sale_price;

  if (price === null || price === undefined || price === "") return "";

  return `${price} ${t("currency")}`;
}